<script async setup lang="ts">
import { CULTURE, getRoomName, getRoomType } from '@/composables/helpers'
import type { IRoomDto } from '@/composables/interfaces/appInterfaces'
import t from '@/i18n/translations'

const props = defineProps<{
  item: IRoomDto | undefined
}>()

const imageUrl = props.item?.assets.gallery[0].format.toString().replace('{0}', 'b') //b is PicSize.Big

let minOccupancy = props.item?.minOccupancy
let maxOccupancy = props.item?.maxOccupancy

let occupancy = ''

if (minOccupancy != null && maxOccupancy != null) {
  occupancy = minOccupancy > 0 ? `${minOccupancy}` : ''

  if (minOccupancy !== maxOccupancy && maxOccupancy > 0) {
    occupancy += occupancy ? `-${maxOccupancy}` : `${maxOccupancy}`
  }
}

let persons = occupancy !== '1' ? t(`${CULTURE}.enquiry.selectedRoom.persons`) : t(`${CULTURE}.enquiry.selectedRoom.person`)
</script>

<template>
  <div class="relative w-full md:w-1/2">
    <div class="pui-acco-card flex h-full max-h-44 flex-row overflow-hidden !rounded shadow-md md:border md:shadow-none">
      <div class="relative w-2/5">
        <div class="h-full overflow-hidden">
          <img class="aspect-video h-full w-full object-cover" :alt="props.item?.assets.gallery[0].title" :src="imageUrl" />
        </div>
      </div>
      <div class="flex w-3/5 flex-col p-3">
        <span class="mb-2 text-lg font-bold">{{ getRoomName(props.item, CULTURE) }}</span>
        <div class="flex flex-wrap">
          <div class="mr-3 flex gap-1">
            <span class="font-semibold">{{ t(`${CULTURE}.enquiry.selectedRoom.type`) + ':' }}</span>
            <span>{{ getRoomType(props.item?.roomtype, CULTURE) }}</span>
          </div>
          <div class="flex gap-1">
            <span class="font-semibold">{{ t(`${CULTURE}.enquiry.selectedRoom.size`) + ':' }}</span>
            <span>{{ props.item?.size }}m&sup2;</span>
          </div>
        </div>
        <div class="flex gap-1">
          <span class="font-semibold">{{ t(`${CULTURE}.enquiry.selectedRoom.occupancy`) + ':' }}</span>
          <span>{{ `${occupancy} ${persons}` }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
